import assetBalance from '../assets/figma/home-icons/asset-balance.png'
import assetCoupons from '../assets/figma/home-icons/asset-coupons.png'
import assetGold from '../assets/figma/home-icons/asset-gold.png'
import assetPoints from '../assets/figma/home-icons/asset-points.png'
import sidebarAddress from '../assets/figma/home-icons/sidebar-address.png'
import sidebarAssets from '../assets/figma/home-icons/sidebar-assets.png'
import sidebarFavorites from '../assets/figma/home-icons/sidebar-favorites.png'
import sidebarFeedback from '../assets/figma/home-icons/sidebar-feedback.png'
import sidebarHistory from '../assets/figma/home-icons/sidebar-history.png'
import sidebarInvite from '../assets/figma/home-icons/sidebar-invite.png'
import sidebarOrders from '../assets/figma/home-icons/sidebar-orders.png'
import sidebarPackage from '../assets/figma/home-icons/sidebar-package.png'
import sidebarRefund from '../assets/figma/home-icons/sidebar-refund.png'
import sidebarUserCenter from '../assets/figma/home-icons/sidebar-user-center.png'
import sidebarWarehouse from '../assets/figma/home-icons/sidebar-warehouse.png'
import summaryOrderCompleted from '../assets/figma/home-icons/summary-order-completed.png'
import summaryOrderPurchased from '../assets/figma/home-icons/summary-order-purchased.png'
import summaryOrderWaitInbound from '../assets/figma/home-icons/summary-order-wait-inbound.png'
import summaryOrderWaitPay from '../assets/figma/home-icons/summary-order-wait-pay.png'
import summaryPackageReceived from '../assets/figma/home-icons/summary-package-received.png'
import summaryPackageShipped from '../assets/figma/home-icons/summary-package-shipped.png'
import summaryPackageWaitPay from '../assets/figma/home-icons/summary-package-wait-pay.png'
import summaryPackageWaitSend from '../assets/figma/home-icons/summary-package-wait-send.png'
import summaryWarehouseInbound from '../assets/figma/home-icons/summary-warehouse-inbound.png'
import summaryWarehousePending from '../assets/figma/home-icons/summary-warehouse-pending.png'
import toolAddress from '../assets/figma/home-icons/tool-address.png'
import toolCanShip from '../assets/figma/home-icons/tool-can-ship.png'
import toolExpertOrder from '../assets/figma/home-icons/tool-expert-order.png'
import toolFavorites from '../assets/figma/home-icons/tool-favorites.png'
import toolFeedback from '../assets/figma/home-icons/tool-feedback.png'
import toolHistory from '../assets/figma/home-icons/tool-history.png'
import toolInvite from '../assets/figma/home-icons/tool-invite.png'
import toolService from '../assets/figma/home-icons/tool-service.png'

export const mallHomeSidebarIconSrcMap: Record<string, string> = {
  'icon-menu-user-center': sidebarUserCenter,
  'icon-time': sidebarHistory,
  'icon-collect2': sidebarFavorites,
  'icon-Wallet': sidebarAssets,
  'icon-order': sidebarOrders,
  'icon-Warehouse': sidebarWarehouse,
  'icon-parcel': sidebarPackage,
  'icon-order-coupon': sidebarRefund,
  'icon-liwuhuodong': sidebarInvite,
  'icon-question1': sidebarFeedback,
  'icon-spiritling-dingwei': sidebarAddress,
}

export const mallHomeAssetIconSrcMap: Record<string, string> = {
  'balance': assetBalance,
  'coupons': assetCoupons,
  'mall-gold': assetGold,
  'points': assetPoints,
}

export const mallHomeSummaryIconSrcMap: Record<string, string> = {
  'order-completed': summaryOrderCompleted,
  'order-purchased': summaryOrderPurchased,
  'order-wait-inbound': summaryOrderWaitInbound,
  'order-wait-pay': summaryOrderWaitPay,
  'package-received': summaryPackageReceived,
  'package-shipped': summaryPackageShipped,
  'package-wait-pay': summaryPackageWaitPay,
  'package-wait-send': summaryPackageWaitSend,
  'warehouse-inbound': summaryWarehouseInbound,
  'warehouse-pending': summaryWarehousePending,
}

export const mallHomeToolIconSrcMap: Record<string, string> = {
  'address': toolAddress,
  'can-ship': toolCanShip,
  'expert-order': toolExpertOrder,
  'favorites': toolFavorites,
  'feedback': toolFeedback,
  'history': toolHistory,
  'invite': toolInvite,
  'service': toolService,
}
